<form autocomplete="off" [formGroup]="itemPrinterForm"
        class="form tw-p-5 tw-flex tw-flex-col">
    <section>
        <mat-label class="tw-text-xl">{{ 'ITEMS.DETAILS.PRINTERS_EXPLAIN' | translate }}</mat-label>
        <div class="tw-flex tw-flex-col" formArrayName="printers">
            @for(printer of itemPrintersFormService.printersArray?.controls; track printer; let i = $index) {
                <div class="tw-w-1/4 tw-py-2" [formGroupName]="i">
                    <mat-checkbox formControlName="_enabled"
                        [disabled]="printer.value._categoryEnabled"
                    >
                    {{ printer.value.name }}
                    @if(printer.value._categoryEnabled) {
                        <span>{{ 'ITEMS.DETAILS.CATEGORY_ENABLED' | translate }}</span>
                    }
                    </mat-checkbox>
                </div>
            }
        </div>
    </section>
</form>